var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThreeDots = function SvgThreeDots(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1364 13.2279C12.8142 13.2279 13.3637 12.6785 13.3637 12.0007C13.3637 11.3229 12.8142 10.7734 12.1364 10.7734C11.4586 10.7734 10.9092 11.3229 10.9092 12.0007C10.9092 12.6785 11.4586 13.2279 12.1364 13.2279Z",
    fill: "#3D3D3D",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1364 4.63808C12.8142 4.63808 13.3637 4.08862 13.3637 3.41084C13.3637 2.73305 12.8142 2.18359 12.1364 2.18359C11.4586 2.18359 10.9092 2.73305 10.9092 3.41084C10.9092 4.08862 11.4586 4.63808 12.1364 4.63808Z",
    fill: "#3D3D3D",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1364 21.8217C12.8142 21.8217 13.3637 21.2722 13.3637 20.5944C13.3637 19.9166 12.8142 19.3672 12.1364 19.3672C11.4586 19.3672 10.9092 19.9166 10.9092 20.5944C10.9092 21.2722 11.4586 21.8217 12.1364 21.8217Z",
    fill: "#3D3D3D",
    stroke: "#3D3D3D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThreeDots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/three-dots.1f78bf9c.svg";
export { ForwardRef as ReactComponent };